module.exports = __webpack_public_path__ + "static/media/SO2.e993a6e5.webp";